/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IEmployeeBranch } from '../../api/domain/channelsuite/user-services/employee-master-data';
import type { IEmployee } from '../../api/domain/channelsuite/user-services/employee-master-data/employee';
import type { ITeam } from '../../api/domain/channelsuite/user-services/employee-master-data/team';

export enum EmployeeMasterDataActions {
    FETCH_BRANCH = 'employee-master-data.fetch.branch',
    FETCH_BRANCH_SUCCESS = 'employee-master-data.result.branch',
    FETCH_BRANCH_FAILURE = 'employee-master-data.error.branch',

    FETCH_TEAM = 'employee-master-data.fetch.team',
    FETCH_TEAM_SUCCESS = 'employee-master-data.result.team',
    FETCH_TEAM_FAILURE = 'employee-master-data.error.team',

    FETCH_EMPLOYEES = 'employee-master-data.fetch.employees',
    FETCH_EMPLOYEES_SUCCESS = 'employee-master-data.fetch.employees.success',
    FETCH_EMPLOYEES_FAILURE = 'employee-master-data.fetch.employees.failure',
}

export const fetchBranch = createAction<string>(EmployeeMasterDataActions.FETCH_BRANCH);
export const fetchBranchSuccess = createAction<IEmployeeBranch>(EmployeeMasterDataActions.FETCH_BRANCH_SUCCESS);
export const fetchBranchFailure = createAction<unknown>(EmployeeMasterDataActions.FETCH_BRANCH_FAILURE);

export const fetchTeam = createAction<string>(EmployeeMasterDataActions.FETCH_TEAM);
export const fetchTeamSuccess = createAction<ITeam>(EmployeeMasterDataActions.FETCH_TEAM_SUCCESS);
export const fetchTeamFailure = createAction<unknown>(EmployeeMasterDataActions.FETCH_TEAM_FAILURE);

export const fetchEmployees = createAction<string[]>(EmployeeMasterDataActions.FETCH_EMPLOYEES);
export const fetchEmployeesSuccess = createAction<IEmployee[]>(EmployeeMasterDataActions.FETCH_EMPLOYEES_SUCCESS);
export const fetchEmployeesFailure = createAction(EmployeeMasterDataActions.FETCH_EMPLOYEES_FAILURE);
